<template>
  <div>
    <section>
      <h3 v-t="$t('ETAB.PAGES.PAYMENT.PAYMENT_MEANS.@BANK_CARD')" />

      <IconLabel
        v-if="cardsCollectionList.length === 0"
        heavy
        :label="$t('ETAB.PAGES.PAYMENT.PAYMENT_MEANS.@BANK_CARD_EMPTY')"
        icon="fad fa-credit-card"
      />

      <QList>
        <QItem v-for="card in cardsCollectionList" :key="card.getId()">
          <QItemSection avatar>
            <QIcon size="40px" :color="card.isCardDefault() ? 'primary' : 'primary-lighter'" :name="getCardIcon(card)" />
          </QItemSection>

          <QItemSection>
            <span :class="[card.isCardDefault() ? 'text-bold' : 'text-primary-lighter']">
              {{ card.getCardDisplayMask() }}
            </span>
          </QItemSection>

          <QItemSection avatar>
            <QIcon class="cursor-pointer" name="fad fa-trash" @click.prevent="removeCard(card)" />
          </QItemSection>
        </QItem>
      </QList>

      <QBtn color="secondary" :label="$t('ETAB.BUTTONS.@ADD')" class="full-width btn-navigation" no-caps @click="$emit('onAddBankCard')" />
    </section>
  </div>
</template>
<script>
  import { CardsCollectionModel } from "@core/models";

  export default {
    props: {
      cardsCollection: { type: Object, default: () => new CardsCollectionModel() },
    },
    emits: ["onAddBankCard", "bankCardAction"],

    computed: {
      cardsCollectionList() {
        return this.cardsCollection.getCards();
      },
    },
    methods: {
      getCardIcon(card) {
        if (card.isVisa()) {
          return "icon-extra-visa";
        }
        if (card.isMastercard()) {
          return "icon-extra-mastercard";
        }
        return "icon-f-credit-card";
      },
      removeCard(bankCard) {
        this.$emit("bankCardAction", bankCard);
      },
    },
  };
</script>
